import { render } from "./AccordionIcon.vue?vue&type=template&id=af69591a"
import script from "./AccordionIcon.vue?vue&type=script&lang=js"
export * from "./AccordionIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__